import * as CdsIcons from '@central-design-system/icons';
import { computed } from 'vue';

import { propsFactory } from '@components/utils';

import type { TCdsIconsName } from '@central-design-system/icons';
import type { TStatus } from '@components/composable';
import type { PropType, ComputedRef } from 'vue';

export type TNotificationLocale = {
  closeLabel?: string;
};

export interface INotificationProps {
  closable?: boolean;
  customIcon?: TCdsIconsName;
  closeLabel?: string;
  closeIcon?: TCdsIconsName;
  status: TStatus;
  icon?: TCdsIconsName | false;
}

export interface IUseNotification {
  icon: ComputedRef<TCdsIconsName | undefined>;
}

export const makeNotificationProps = propsFactory(
  {
    /**
     * Иконка
     */
    icon: {
      type: [Boolean, String, Function, Object] as PropType<false | TCdsIconsName>,
      default: null
    },
    /**
     * Своя иконка
     */
    customIcon: {
      type: String as PropType<TCdsIconsName | undefined>,
      default: undefined,
      validator: (value?: TCdsIconsName) => (value ? CdsIcons.allowedIcons.includes(value) : true)
    },
    /**
     * Кнопка закрытия
     */
    closable: {
      type: Boolean,
      default: false
    },
    /**
     * Лейбл кнопки закрытия
     */
    closeLabel: {
      type: String as PropType<string>,
      default: 'Закрыть'
    },
    /**
     * Иконка кнопки закрытия
     */
    closeIcon: {
      type: String as PropType<TCdsIconsName>,
      default: 'remove',
      validator: (value: TCdsIconsName) => CdsIcons.allowedIcons.includes(value)
    }
  },
  'notification'
);

export function useNotification(props: INotificationProps): IUseNotification {
  const icon = computed<TCdsIconsName | undefined>(() => {
    if (props.icon === false) return undefined;

    if (props.customIcon) return props.customIcon;

    if (props.status === 'warning') return 'alert';
    if (props.status === 'success') return 'check';
    if (props.status === 'progress') return 'clock';

    return `${props.status}`;
  });

  return {
    icon
  };
}
